import { useEffect, useState } from "react";

import { BREAKPOINT } from "@/configs/breakpoints";

// Convert a breakpoint to a media query string (eg. viewport width is <= breakpoint)
const getMediaQuery = (breakpoint: BREAKPOINT) => `(max-width: ${breakpoint})`;

/**
 * Hook returns if the viewport size matches a breakpoint
 */
export const useMediaQuery = (breakpoint: BREAKPOINT): boolean => {
    const [matches, setMatches] = useState<boolean>(() => {
        // Get initial state based on current viewport
        const media = window.matchMedia(getMediaQuery(breakpoint));
        return media.matches;
    });

    useEffect(() => {
        const media = window.matchMedia(getMediaQuery(breakpoint));

        // Set initial state (in case it changed between render and effect)
        setMatches(media.matches);

        const handleChange = () => setMatches(media.matches);
        media.addEventListener("change", handleChange);

        return () => media.removeEventListener("change", handleChange);
    }, [breakpoint]);

    return matches;
};
